import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../../common_nextgen/common_components/common-hooks/useLocationState";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";

const useBenefitMaxSchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectModeParamData,
  onNavigate
) => {
  const [data, setData] = useState([]); /* Benefit Max Schedule Data */
  // const [paramsData, setParamsData] = useState({
  //   bscScheduleName: "",
  //   hiddenRecordIndicator: "Active",
  // });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [hideflag, setHideFlag] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  //const [selectMode, setSelectMode] = useState(initial)
  const toast = useToast();
  const location = useLocation();
  const {
    BENEFIT_MAX_SCHEDULE_ADD,
    BENEFIT_MAX_SCHEDULE_EDIT,
    COPY_BENEFIT_MAX_SCHEDULE,
    BENEFIT_MAX_SCHEDULE_NOTE,
    BENEFIT_MAX_SCHEDULE_DISPLAY,
    BENEFIT_MAX_STEP_SCHEDULE_SEARCH,
  } = ROUTE_PATHS;

  const screen_title = "Benefit Max Schedule";
  // const screenNumber = "RCBSC001";
  const statusKey = "hiddenRecordIndicator";
  const { axios_helper_no_header } = useAxios();

  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state || [],
  });
  const {
    selectedSchedules = [],
    selectedCodesListItem = "",
    previousScreen = "",
    currentIndex: initialIndex = 0,
    // selectMode=false,
    paramsData: initialParamsData = {
      bscScheduleName: "",
      hiddenRecordIndicator: "Active",
    },
    externalMode: initialExternalMode = false,
  } = currentState;

  const [externalMode, setExternalMode] = useState(initialExternalMode);
  useReceiveExternalMessages(setStateVal, setExternalMode);

  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [disabledDropdowns, setDisabledDropdowns] = useState({});

  const initialParams = selectMode
    ? { ...selectModeParamData, hiddenRecordIndicator: "Active" }
    : initialParamsData;

  const screenNumber = selectMode ? "RCBSC005" : "RCBSC001";

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(initialParams);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.bscScheduleName;
  const updatedParamsData = {
    ...paramsData,
    bscScheduleName: lastScheduleName,
  };

  /* Search form fields that needs to be shown for filtering */
  const formFields = selectMode
    ? [
        {
          fieldLabel: "BSC Schedule Name",
          name: "bscScheduleName",
          label: "Schedule",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          value: "",
          maxLength: 1,
        },
      ]
    : [
        {
          fieldLabel: "BSC Schedule Name",
          name: "bscScheduleName",
          label: "Schedule",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          value: "",
          maxLength: 1,
        },
      ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else {
      hideModal();
      /*const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");*/
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Benefit Max Schedule",
          button_handeler: () => {
            navigateToPage(BENEFIT_MAX_SCHEDULE_ADD, [
              {
                previousScreen: location.pathname,
                externalMode,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              // const [latestPreviousState]=previousState.splice(previousState.length-1,1);
              // let {paramsData}=latestPreviousState;
              // console.log("paramsData",paramsData,latestPreviousState);

              // // const updatedParamsData={...paramsData,bmdScheduleCode:rowData[parmKey], bmdDescription:rowData[bmdDescription]};

              // const updatedParamsData={...paramsData,aocScheduleOverride:rowData[parmKey]};
              // const updatedLatestPreviousState={...latestPreviousState,initialParamsData:updatedParamsData}
              // navigateToPage(previousScreen,[...previousState,updatedLatestPreviousState])

              const paramDataMap = new Map();
              selectParams.forEach((key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                  paramDataMap.set(key["source"], rowData[key["target"]]);
                }
              });
              const paramData = Object.fromEntries(paramDataMap);
              if (lookupType !== "external") {
                onSelect(paramData);
              } else {
                window.parent.postMessage(
                  { type: "responseData", data: paramData },
                  "*"
                );
              }
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              /*  const message = {
                message: "navigate-to-presto",
                programCode: "RCBSC002I",
                parameters: {
                  bscScheduleName: rowData["bscScheduleName"],
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");*/
              if (lookupType !== "external") {
                onNavigate({
                  navType: "local",
                  data: rowData,
                  target: ROUTE_PATHS.BENEFIT_MAX_SCHEDULE_DISPLAY,
                  schedulesDataKey: "selectedPriceSchedules",
                });
              } else {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "BENEFIT_MAX_SCHEDULE_READ_ONLY",
                  schedulesDataKey: "selectedPriceSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              }
            },
          },
          {
            label: "Steps",
            icon: <span className="material-icons">search</span>,
            command: () => {
              /* const message = {
                message: "navigate-to-presto",
                programCode: "RCBSD001I",
                parameters: {
                  bscScheduleName: rowData["bscScheduleName"],
                  bscBasis: rowData["bscBasis"],
                  bscDescription: rowData["bscDescription"],
                  bscStepCount: rowData["wrkNumber"],
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");*/
              if (lookupType !== "external") {
                onNavigate({
                  navType: "local",
                  data: rowData,
                  target: ROUTE_PATHS.BENEFIT_MAX_STEP_SCHEDULE_SEARCH,
                  schedulesDataKey: "selectedPriceSchedules",
                });
              } else {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "BENEFIT_MAX_SCHEDULE_STEPS",
                  schedulesDataKey: "selectedPriceSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              }
            },
          },
        ]
      : [
          {
            label: "Note",
            icon: <span className="material-icons">note</span>,
            command: () => {
              navigateToPage(BENEFIT_MAX_SCHEDULE_NOTE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  selectedPriceSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  description: rowData.bscDescription,
                },
              ]);
            },
          },
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              navigateToPage(BENEFIT_MAX_SCHEDULE_EDIT, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  selectedPriceSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Copy",
            icon: <span className="material-icons">content_copy</span>,
            command: () => {
              navigateToPage(COPY_BENEFIT_MAX_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  selectedPriceSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              navigateToPage(BENEFIT_MAX_SCHEDULE_DISPLAY, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  selectedPriceSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Steps",
            icon: <span className="material-icons">search</span>,
            command: () => {
              navigateToPage(BENEFIT_MAX_STEP_SCHEDULE_SEARCH, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  selectedPriceSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
            icon: <span className="material-icons">visibility_off</span>,
            command: () => {
              openHideConfirmationModal();
            },
          },
        ];
  }, [rowData]);

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "bscScheduleName",
    },
    {
      header: "Description",
      field: "bscDescription",
    },
    {
      header: "Basis",
      field: "bscBasis",
      style: { width: "5%" },
    },
    {
      header: "Steps",
      field: "wrkNumber",
      style: { width: "5%" },
    },
    {
      header: "Indicators",
      field: "noteExistenceStatus",
      body: (rowData) => (
        <IndicatorCell
        rowData={rowData}
        fields={[
          "noteExistenceStatus",
        ]}
        tooltipContent={{
          noteExistenceStatus: "Notes",
        }}
      />
      ),
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
      style: { width: "5%" },
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "bscScheduleName";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/bscBenefitSchCtrl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideflag, lookupType]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const hideBenefitMaxSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        bscScheduleName: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/bscBenefitSchCtrl/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          setHideFlag(!hideflag);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const deleteBenefitMaxSchedule = () => {
    if (selectedOption === "yes") {
      const params = { bscScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/bscBenefitSchCtrl", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber: screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/bscBenefitSchCtrl/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "initData") {
        const externalData = data?.data || {};
        setSelectedMode(data?.selectMode);
        setLookupType("external");
        setParamsData({ ...paramsData, ...externalData?.paramsData });
        setSelectParams(externalData?.params);
        setDisabledDropdowns({ hiddenRecordIndicator: true });
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    leftButtons,
    updateParamData,
    ctaButtons,
    selectMode,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteBenefitMaxSchedule,
    hideBenefitMaxSchedule,
    setSelectedOption,
    hideBenefitMaxSchedule,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    disabledDropdowns,
  };
};

export default useBenefitMaxSchedule;
